<template>
    <div class="content">
        <div class="content-head"  v-if="showQuery">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="发货状态">
                    <el-select v-model="params.status" placeholder="请选择" class="el-select-medium">
                        <el-option v-for="item in shippingStatusopt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="发货类型" v-if="isFiltration">
                    <el-select v-model="params.orders_delivery_deliverytype" placeholder="请选择" class="el-select-medium">
                        <el-option v-for="item in shippingTypeopt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="订单号">
                    <el-input  autocomplete="on" name="keyword" v-model="params.keyword" placeholder="请输入订单号" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="业务员">
                    <el-input autocomplete="on" name="officeman" v-model="params.officemanname" placeholder="请输入订单号" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="申请单号" v-if="isFiltration">
                    <el-input autocomplete="on" name="applysn" v-model="params.applysn" placeholder="请输入申请单号" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="客户名称">
                    <el-input autocomplete="on" name="customername" v-model="params.customername" placeholder="请输入客户名称" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="ERP发货审批单号">
                    <el-input autocomplete="on" name="erpcode" v-model="params.erpcode" placeholder="请输入ERP发货审批单号" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="起止时间" v-if="isFiltration">
                    <el-date-picker v-model="params.date_start" type="date" placeholder="开始日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                    <span style="margin: 0 5px">至</span>
                    <el-date-picker v-model="params.date_end" type="date" placeholder="结束日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getOrdersDeliverys(true)" icon="el-icon-search" :loading="loadingBtn">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onRefresh" icon="el-icon-refresh">重置</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="setFiltration" :icon="!isFiltration ? 'el-icon-arrow-down' : 'el-icon-arrow-up'">
                        {{ !isFiltration ? '展开' : '收起' }}
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-table">
            <div class="content-table-title"  v-if="showQuery">
                发货申请单列表
                <el-dropdown trigger="click">
                    <el-button type="primary">
                        导出
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>
                            <span @click="getOrdersDeliveryExport()">导出勾选信息</span>
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <span @click="getOrdersDeliveryExportAll()">导出查询信息</span>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <el-table  @row-click="handleRowMultipleClick" :row-class-name="tableRowMultipleClassName"  :data="dispatchnoteList" ref="multipleTable" border :height="maxheight" style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }" v-loading="loadingBtn" @selection-change="handleSelectionChange">
                <el-table-column type="selection"  v-if="showQuery" width="50" fixed align="center" />
                <!-- <el-table-column prop="Orders_Delivery_ID" label="ID" width="60" align="center" /> -->
                <el-table-column prop="Orders_SN" label="订单编号" show-overflow-tooltip fixed width="120" align="center">
                    <template slot-scope="scope">
                        <div class="operation-bar">
                            <span class="operation-bar-block" @click="handleViewsDetail(scope.row)">{{ scope.row.Orders_SN }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="Apply_SN" label="申请单号" show-overflow-tooltip fixed width="150" align="center"></el-table-column>
                <el-table-column prop="Orders_Delivery_ERPSN" show-overflow-tooltip label="ERP发货审批单号" width="150" align="center"></el-table-column>
                <el-table-column prop="Orders_CustomerName" show-overflow-tooltip width="250" label="客户名称" align="left"></el-table-column>
                <el-table-column prop="Orders_ProjectName" show-overflow-tooltip width="250" label="工程名称" align="left"></el-table-column>
                <el-table-column prop="DeliveryStatus" label="发货状态" show-overflow-tooltip align="center">
                    <template slot-scope="scope">
                        <span :class="judgeColor(scope.row.DeliveryStatus)">{{ scope.row.DeliveryStatus }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="DeliveryType" label="发货类型" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="DeliverySyncStatus" label="同步状态" align="center">
                    <template slot-scope="scope">
                        <span :class="judgeColor(scope.row.DeliveryStatus)">{{ scope.row.DeliverySyncStatus }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="操作时间" show-overflow-tooltip width="170" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.createTime | formatDates }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="100">
                    <template slot-scope="scope">
                        <div class="operation-bar">
                            <span class="operation-bar-block" @click="handleSerch(scope.row)">查看</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div>
                <Pagination :paginationOptions="paginationOptions" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>
        <DispatchnoteDetails :isShowDialog="isShowDialog" :Orders_Delivery_ID="Orders_Delivery_ID" @handleClose="handleClose" />
    </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
import DispatchnoteDetails from './components/DispatchnoteDetails.vue';
import { formatDate, downloadFile, toLowerCaseKeys } from '@/utils/utils.js';
import { myMixin } from '@/utils/mixin.js';
import { cloneDeep } from 'lodash';
export default {
    name: 'deliveryRequisition',
    mixins: [myMixin],
    components: {
        Pagination,
        DispatchnoteDetails
    },
    props: {
        showQuery: {
            type: Boolean,
            default: true
        },
        projectName: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            loadingBtn: false,
            isFiltration: false,
            isShowDialog: false,
            params: {
                date_start: '',
                date_end: '',
                status: 0,
                orders_delivery_deliverytype: 0,
                keyword: '',
                applysn: '',
                erpcode: '',
                customername: '',
                projectName: this.showQuery?'':this.projectName
            },
            Orders_Delivery_ID: '',
            timer: [],
            dispatchnoteList: [],
            handselectIds: [],
            shippingStatusopt: [
                { value: 0, label: '全部单据' },
                { value: 1, label: '未发货' },
                { value: 2, label: '已经发货' }
            ],
            shippingTypeopt: [
                { value: 0, label: '全部' },
                { value: 1, label: '现场设备' },
                { value: 2, label: '控制柜' },
                { value: 3, label: '挪货' }
            ],
            multipleSelection: [],
        };
    },
    mounted() {
        this.getOrdersDeliverys(true);
    },
    methods: {
        //展开收起
        setFiltration() {
            this.isFiltration = !this.isFiltration;
        },
        handleSelectionChange(e) {
            this.multipleSelection = e;
            this.handselectIds = e.map((item) => item.Orders_Delivery_ID);
            console.log(e, this.handselectIds);
        },
        handleRowMultipleClick(row) {
            this.$refs.multipleTable.toggleRowSelection(row);
        },
        tableRowMultipleClassName({ row }) {
            if (this.multipleSelection.some(item => item.Orders_Delivery_ID === row.Orders_Delivery_ID)) {
                return 'multiple-selection-row';
            }
            return '';
        },
        handleSizeChange(newSize) {
            this.paginationOptions.PageSize = newSize;
            this.getOrdersDeliverys();
        },
        handleCurrentChange(newPage) {
            this.paginationOptions.Page = newPage;
            this.getOrdersDeliverys();
        },
        handleSerch(row) {
            this.Orders_Delivery_ID = row.Orders_Delivery_ID + '';
            this.isShowDialog = true;
        },
        async handleViewsDetail(row) {
            
                this.$store.commit('SET_TAGTITLE', '订单详情');
                this.$router.push(`/orderManagement/orderDetails?id=${row.Orders_Delivery_OrdersID}`);
                this.id = row.Orders_ID;

            
            return;

           
        },
        handleClose() {
            this.isShowDialog = false;
        },
        //重置
        onRefresh() {
            this.params = {
                date_start: '',
                date_end: '',
                status: 0,
                orders_delivery_deliverytype: 0,
                keyword: '',
                applysn: '',
                erpcode: '',
                customername: ''
            };
            this.getOrdersDeliverys(true);
        },
        //申请单管理列表
        getOrdersDeliverys(flag = false) {
            this.loadingBtn = true;
            if (flag) {
                this.paginationOptions = {
                    Page: 1,
                    total: 0,
                    PageSize: 40
                };
            }
            this.$newsApi
                .getOrdersDeliverys(this.filteropt())
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.dispatchnoteList = res.data.data;
                        this.dispatchnoteList.map((item) => {
                            item.createTime = item.Orders_Delivery_Addtime;
                        });
                        this.paginationOptions.total = res.data.RecordCount;
                    } else {
                        this.tableList = [];
                        this.paginationOptions.total = 0;
                    }
                })
                .finally(() => (this.loadingBtn = false));
        },

        filteropt() {
            let params = cloneDeep(this.params);
            return { json: JSON.stringify(toLowerCaseKeys(params)), Page: this.paginationOptions.Page, PageSize: this.paginationOptions.PageSize };
        },
        // 选中导出
        getOrdersDeliveryExport() {
            if (this.handselectIds.length == 0) {
                this.$message({
                    message: '请选择要导出的信息',
                    type: 'warning'
                });
                return;
            }
            let handselectIds = this.handselectIds.join(',');
            this.$newsApi.getOrdersDeliveryExport({ ordersid: handselectIds }).then((res) => {
                if (res.data.Resultcode == 0) {
                    downloadFile(res.data.data, res.data.Resultinfo);
                }
            });
        },
        //导出所有
        getOrdersDeliveryExportAll() {
            this.$newsApi.getOrdersDeliveryExportAll(this.filteropt()).then((res) => {
                if (res.data.Resultcode == 0) {
                    downloadFile(res.data.data, res.data.Resultinfo);
                }
            });
        }
    }
};
</script>
<style scoped lang="scss">
.content-head {
    padding: 15px 20px 5px 20px;
}
.el-form-item--small.el-form-item {
    margin-bottom: 5px;
}
</style>